import { tw } from '@/utils/tw';
import BaseMorePagesTitleTheme from 'base/components/MorePagesTitle/theme';

const MorePagesTitle = tw.theme({
  extend: BaseMorePagesTitleTheme,
  base: `max-w-tabloid relative mx-auto bg-gray-100 p-3 wings wings-gray-100 text-headline-md`,
});

export default MorePagesTitle;
